import { useEffect, useCallback, useRef } from 'react';

const useOutsideClick = (outsideCallback) => {
  const node = useRef();

  const handleOutSideClick = useCallback(
    (e) => {
      if (node.current.contains(e.target)) {
        return;
      }
      outsideCallback();
    },
    [outsideCallback],
  );
  useEffect(() => {
    document.body.addEventListener('click', handleOutSideClick);
    return function cleanup() {
      document.body.removeEventListener('click', handleOutSideClick);
    };
  }, [handleOutSideClick]);

  return node;
};

export default useOutsideClick;
